// export { default as MonitoringProvider } from './console';
export { default as MonitoringProvider } from './sentry';
